import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const SectionDefaultLayout = styled.div`
  background-color: #f8f8f8;

  padding-bottom: 128px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding-bottom: 64px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding-bottom: 64px;
  }
`;
